import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { baseUrl, userLocation, ipAddress, userName, formatDateTime } from '../Univ.js';

function EqpNewProduct() {
    const [isLoading, setIsLoading] = useState(false);
    const [subcats, setSubcats] = useState([]);
    const [rows, setRows] = useState([{ id: '', hsn: '', product: '', pack: '', fqty: '', totqty: '', pprice: '', mrp: '', disc: '', sgst: '', cgst: '', subcat: ''}]);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [selectedDate1, setSelectedDate1] = useState(new Date());
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');

    const [pharmData, setpharmData] = useState({
        product: '',
        pack: '',
        qty: '',
        fqty: '',
        totqty: '',
        mrp: '',
        pprice: '',
        disc: '',
        sgst: '',
        cgst: '',
        netamount: '',
        gstamount: '',
        status: '',
        addedby: '',
        ip_add: '',
        subcat: '',
    });
    useEffect(() => {
    axios.get(`${baseUrl}eqp-subcat/`)
      .then(response => setSubcats(response.data))
      .catch(error => console.log(error));

    }, []);

    const handleAmountChange = (e, index) => {
        const newRows = [...rows];
        const { name, value } = e.target;

        newRows[index] = {
            ...newRows[index],
            [name]: parseFloat(value) || 0
        };

        const { pack, qty, pprice, mrp, disc, fqty, sgst, cgst } = newRows[index];

        newRows[index].totqty = pack * qty;
        const net = pprice * qty;
        const disc1 = disc / 100;
        const disca = net * disc1;
        const dism = net - disca;
        const gst = parseFloat(sgst) + parseFloat(cgst);
        const tax1 = (gst / 100) * dism;
        newRows[index].netamount = (dism + tax1);
        newRows[index].gstamount = tax1;
        setRows(newRows);
    };

    const handleDateChange = (date) => {
        if (date) {
            const dateString = date.toISOString().slice(0, 10);
            const dateObj = new Date(dateString);
            dateObj.setHours(0, 0, 0, 0);
            setSelectedDate(dateObj);
        }
    };

    const handleDateChange1 = (date) => {
        if (date) {
            const dateString = date.toISOString().slice(0, 10);
            const dateObj = new Date(dateString);
            dateObj.setHours(0, 0, 0, 0);
            setSelectedDate1(dateObj);
        }
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;
        setpharmData(prevState => ({ ...prevState, [name]: value }));
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index] = {
                ...newRows[index],
                [name]: value
            };
            return newRows;
        });
    };

    const formSubmit = () => {
        const formData = new FormData();
        const unet = parseFloat(rows.map(row => row.mrp) / rows.map(row => row.pack));
        const totqty = parseFloat(rows.map(row => row.totqty) / rows.map(row => row.fqty));

        formData.append('hsn', rows.map(row => row.hsn));
        formData.append('product', rows.map(row => row.product));
        formData.append('pack', rows.map(row => row.pack));
        formData.append('qty', 0);
        formData.append('totqty', 0);
        formData.append('subcat', rows.map(row => row.subcat));
        formData.append('unit', rows.map(row => row.unit));
        formData.append('mrp', rows.map(row => row.mrp));
        formData.append('pprice', rows.map(row => row.pprice));
        formData.append('sprice', rows.map(row => row.mrp));
        formData.append('disc', rows.map(row => row.disc));
        formData.append('sgst', rows.map(row => row.sgst));
        formData.append('cgst', rows.map(row => row.cgst));
        formData.append('netamount', rows.map(row => row.netamount.toFixed(2)));
        formData.append('gstamount', rows.map(row => row.gstamount.toFixed(2)));
        formData.append('uamount', unet.toFixed(2));
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);

        axios.post(`${baseUrl}add-equip/`, formData)
            .then(response => {

            })
            .catch(error => {
                console.log(error);
            });

        Swal.fire({
            title: 'Equipment Product Added.',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false
        });
        setTimeout(() => {
            window.location.href = '/add-eqp-product/';
        }, 3000);
    };

    return (
        <section className="container mt-4">
            <form>
                <div className='table-responsive'>
                    <table className="erp-table-modern">
                        <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                <th style={{width: 120}}>HSN</th>
                                <th style={{width: 370}}>Equip Category</th>
                                <th style={{width: 370}}>Equip Name</th>
                                <th style={{width: 90}} >Pack</th>
                                <th style={{width: 120}} >Qty</th>
                                <th style={{width: 90}} >TotQty</th>
                                <th style={{width: 90}} >Unit</th>
                                <th style={{width: 120}} >PPrice</th>
                                <th style={{width: 120}} >Mrp</th>
                                <th style={{width: 110}} >Disc %</th>
                                <th style={{width: 110}} >SGST %</th>
                                <th style={{width: 110}} >CGST %</th>
                                <th style={{width: 120}}>Net Amount<br />(Incl.GST)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="text"
                                            name="id"
                                            value={row.id || 0}
                                            onChange={e => handleChange(e, index)}
                                            style={{width: 80, display: 'none'}}
                                            tabIndex={0}
                                            readOnly
                                        />
                                        <input
                                            type="text"
                                            name="hsn"
                                            value={row.hsn}
                                            onChange={e => handleChange(e, index)}
                                            style={{width: 80}}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <select name="subcat" id="subcat" value={row.subcat} onChange={(e) => {
                                                handleChange(e, index);
                                            }}
                                            className="form-control"
                                            >
                                            <option>Select Category</option>
                                          {subcats.map((subcat, index) => (
                                            <option key={index} value={subcat.id}>{subcat.subcat}</option>
                                          ))}
                                        </select>
                                      </td>
                                    <td>
                                        <input
                                            type="text"
                                            name="product"
                                            value={row.product}
                                            onChange={e => handleChange(e, index)}
                                            style={{width: 150}}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            className="ms-2 me-1"
                                            name="pack"
                                            style={{width: 60}}
                                            value={row.pack}
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 70 }}
                                            className="ms-2 me-1"
                                            value={row.qty}
                                            name="qty"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                            required
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 90 }}
                                            className="ms-2 me-1"
                                            value={row.totqty}
                                            name="totqty"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            style={{ width: 90 }}
                                            className="ms-2 me-1"
                                            value={row.unit}
                                            name="unit"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 90 }}
                                            className="ms-2 me-1"
                                            value={row.pprice}
                                            name="pprice"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 90 }}
                                            className="ms-2 me-1"
                                            value={row.mrp}
                                            name="mrp"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 50 }}
                                            className="ms-2 me-1"
                                            value={row.disc}
                                            name="disc"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 50 }}
                                            className="ms-2 me-1"
                                            value={row.sgst}
                                            name="sgst"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 50 }}
                                            className="ms-2 me-1"
                                            value={row.cgst}
                                            name="cgst"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            style={{ width: 90 }}
                                            className="ms-2 me-1"
                                            value={row.netamount}
                                            name="netamount"
                                            onChange={(e) => {
                                                handleChange(e, index);
                                                handleAmountChange(e, index);
                                            }}
                                            tabIndex={0}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button"  onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
</div>
            </form>
        </section>
    );
}

export default EqpNewProduct;
